import axios from 'axios'
import {accessSessionTokenKeyName} from 'src/utils/constants'
import {getValidAdminAccessToken} from 'src/utils/impersonationTokens'
import {
  isInvalidTokenApiError,
  performSessionExpiredLogout,
} from 'src/utils/sessionExpiredLogout'

type REQUEST_METHODS = 'GET' | 'POST' | 'PUT' | 'DELETE'
type ENDPOINT = string
type PARAMS = Object

const getTokenSync = () => {
  return localStorage.getItem(accessSessionTokenKeyName)
}

function handleUnauthorizedTokenError(error: any, toolkit: any, token: string | null): boolean {
  if (!token || error?.response?.status !== 401 || !isInvalidTokenApiError(error)) {
    return false
  }

  performSessionExpiredLogout(toolkit.dispatch)
  toolkit.rejectWithValue(error.response)
  return true
}

const AxiosClientForFile = async (
  method: REQUEST_METHODS,
  endPoint: ENDPOINT,
  payload: any,
  toolkit: any,
  params: PARAMS
) => {
  const token = getTokenSync()

  try {
    const logInAdminAccessToken = getValidAdminAccessToken()

    const response = await axios({
      url: process.env.REACT_APP_API_URL + endPoint,
      method: method,
      data: payload,
      params: {...params},
      headers: {
        Accept: 'application/json',
        ...(payload instanceof FormData ? {} : {'Content-Type': 'application/json'}),
        Authorization: `Bearer ${token}`,
        xadmin: logInAdminAccessToken ? logInAdminAccessToken : null,
      },
    })

    return toolkit.fulfillWithValue(response.data)
  } catch (error: any) {
    console.log('error:', error)
    if (handleUnauthorizedTokenError(error, toolkit, token)) {
      return
    }
    return toolkit.rejectWithValue(error.response)
  }
}

const publicAxiosClient = async (method: REQUEST_METHODS, endPoint: ENDPOINT, payload: any) => {
  try {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }

    const response = await axios({
      url: process.env.REACT_APP_API_URL + endPoint,
      method: method,
      data: payload,
      headers,
    })

    return response.data
  } catch (error) {
    console.error('error:', error)
  }
}

const AuthenticatedAxiosClient = async (
  method: string,
  endPoint: string,
  payload: any,
  toolkit: any,
  params: any
) => {
  const token = getTokenSync()
  const logInAdminAccessToken = getValidAdminAccessToken()

  try {
    const response = await axios({
      url: process.env.REACT_APP_API_URL + endPoint,
      method: method,
      data: payload,
      params: {...params},
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        ...(payload instanceof FormData ? {} : {'Content-Type': 'application/json'}),
        xadmin: logInAdminAccessToken ? logInAdminAccessToken : null,
      },
    })
    return toolkit.fulfillWithValue(response.data)
  } catch (error: any) {
    console.error('Error with authenticated request:', error)
    if (handleUnauthorizedTokenError(error, toolkit, token)) {
      return
    }
    return toolkit.rejectWithValue(error.response)
  }
}

export {publicAxiosClient, AuthenticatedAxiosClient, AxiosClientForFile}
export default AxiosClientForFile
